module.exports = __webpack_public_path__ + "img/SWE.c643499a.png";